{
  "Find us": "Hitta oss",
  "address-street": "Vasagatan 12, 4th floor",
  "address-postal": "111 20 Stockholm",
  "address-country": "Sverige",
  "Links": "Länkar",
  "Contact Support": "Kontakta support",
  "Changelog": "Plattforms-uppdateringar",
  "Collegial logo": "Collegials logotyp",
  "Knowledge base": "Knowledge base"
}
